/**
 * The Octail module has no pages of its own: its ProductConfig, ClientPanel and AdminPanel are
 * picked up by the catalog and provisioning pages (docs/dev/architecture.md §10).
 */
export default { name: 'octail' };
